export { default } from "./ProseMirrorImageBlock";
